function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39 9a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm4.5 10.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 15a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm-9-22.13h-33a1.5 1.5 0 01-1.5-1.5V7.13a1.5 1.5 0 011.5-1.5h33a1.5 1.5 0 011.5 1.5v3.75a1.5 1.5 0 01-1.5 1.5zm0 15h-33a1.5 1.5 0 01-1.5-1.5v-3.75a1.5 1.5 0 011.5-1.5h33a1.5 1.5 0 011.5 1.5v3.75a1.5 1.5 0 01-1.5 1.5zm0 15h-33a1.5 1.5 0 01-1.5-1.5v-3.74a1.5 1.5 0 011.5-1.5h33a1.5 1.5 0 011.5 1.5v3.74a1.5 1.5 0 01-1.5 1.5z"
})));